import router from '../router';
import {getCurrentAuthToken} from '../auth/user-meta'
import clipsapi from "../api/clip"
import favPlace from '../api/clip_place'

const loader = document.getElementById("loading");

// console.log(loader);

/**
 * Redirect After Login & Register
 */
export function redirectToInheritedPage(){
    return new Promise((resolve, reject) => {

        let inheritedArticleLink = window.localStorage.getItem('inherited_url'),
            inheritedPlaceIdLink = window.localStorage.getItem('placeBookmarked_inherited_url'),
            inheritFormArticleLink = window.localStorage.getItem('form_inherited_url'),
            inheritedArtcileData = tryParseJSON(window.localStorage.getItem('inheritedClipArticle')),
            inheritedPlaceData = tryParseJSON(window.localStorage.getItem('inheritedPlaceClip'));


        if(inheritedArtcileData){
            clipInheritedArticle(inheritedArtcileData)
                .then(res => {
                    // console.log(res);
                    window.localStorage.removeItem('inheritedClipArticle');
                    window.localStorage.removeItem('inherited_url')
                    if(inheritedArticleLink && inheritedArticleLink !== void 0){
                        // console.log(`redirect to ${inheritedArticleLink}`)
                        loader.style.display = "none";
                        window.location.href = inheritedArticleLink;
                    }else{
                        // console.log(`redirect to ${inheritedArticleLink}`)
                        loader.style.display = "none";
                        router.push('/');
                    }
                    
                })
                .catch(err => {
                    // console.log(err)
                    loader.style.display = "none";
                    router.push('/');
                })
        }else if(inheritedPlaceData){
            clipInheritedPlace(inheritedPlaceData)
                .then(res => {
                    // console.log(res)
                    window.localStorage.removeItem('inheritedPlaceClip');
                    window.localStorage.removeItem('placeBookmarked_inherited_url')
                    if(inheritedPlaceIdLink && inheritedPlaceIdLink !== void 0){
                        // console.log(`redirect to ${inheritedPlaceIdLink}`)
                        loader.style.display = "none";
                        window.location.href = inheritedPlaceIdLink;
                    }else{
                        // console.log(`redirect to ${inheritedPlaceIdLink}`)
                        loader.style.display = "none";
                        router.push('/');
                    }

                })
                .catch(err => {
                    // console.log(err)
                    loader.style.display = "none";
                    router.push('/');
                })
        }else if(inheritFormArticleLink){
            window.localStorage.removeItem('form_inherited_url');
            window.localStorage.removeItem('inherited_form_data')
            if(inheritFormArticleLink && inheritFormArticleLink !== void 0){
                loader.style.display = "none";
                window.location.href = inheritFormArticleLink;
            }else{
                loader.style.display = "none";
                router.push('/');
            }            
        }
        else{
            loader.style.display = "none";
            router.push('/');
        }
    })
}


/**
 * Clip Inherited Article Id
 * @param {*} data 
 */
export function clipInheritedArticle(data){
    return new Promise((resolve, reject) => {
        getCurrentAuthToken()
            .then(token => {

                clipsapi.addArticleToFavorite({articleId: data.article_id, lang_id: data.lang_id}, token)
                    .then(res => {
                        // console.log(res)
                        resolve(res)
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
            .catch(error => {
                reject(error)
            })
    })
}


/**
 * Clip Inherited Place Id
 * @param {*} data 
 */
export function clipInheritedPlace(data){
    return new Promise((resolve, reject) => {
        getCurrentAuthToken()
            .then(token => {
                favPlace.addPlaceIdClip({placeId: data.place_id, lang_id: data.lang_id}, token)
                    .then(res => {
                        // console.log(res)
                        resolve(res)
                    })
                    .catch(err => {
                        // console.log(err)
                        reject(err)
                    })
            })
            .catch(error => {
                reject(error)
            })        

    })
}



/**
 * ref: https://stackoverflow.com/questions/3710204/how-to-check-if-a-string-is-a-valid-json-string-in-javascript-without-using-try/3710226
 * @param {*} jsonString 
 */
export function tryParseJSON (jsonString){
    try {
        var o = JSON.parse(jsonString);

        // Handle non-exception-throwing cases:
        // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
        // but... JSON.parse(null) returns null, and typeof null === "object", 
        // so we must check for that, too. Thankfully, null is falsey, so this suffices:
        if (o && typeof o === "object") {
            return o;
        }
    }
    catch (e) { }

    return false;
};


// WEBPACK FOOTER //
// ./src/auth/routing.js